import styled, { css } from 'styled-components';
import { th, variants } from 'style/theme';
import { sizes } from 'style';
import Button from '../Button';

export const AddButton = styled(Button)`
  justify-self: flex-end;
  margin-top: 6px;
  max-width: 300px;
  width: 100%;

  > svg {
    margin-right: 2px;

    > path {
      fill: ${th('colors.pickledBluewood')};
    }
  }

  :hover,
  :focus {
    background-color: transparent;
  }

  @media ${sizes.desktop} {
    :hover {
      background-color: ${({ disabled }) => !disabled && th('colors.fountainBlue+2')};
    }
  }

  ${({ $selected }) =>
    $selected &&
    css`
      background-color: ${th('colors.fountainBlue')};
      box-shadow: none;

      :hover,
      :focus {
        background-color: ${th('colors.fountainBlue')};
      }

      :focus {
        outline: none;
      }
    `}

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 40%;
    `};
`;

export const StyledAddonCard = styled.div`
  flex: 1;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 16px;
  border-radius: 16px;
  background-color: ${({ $selected }) =>
    $selected ? th('colors.fountainBlue+3') : th('colors.fountainBlue+4')};
  transition: background-color 200ms;
  user-select: none;

  ${({ $disabled }) =>
    $disabled &&
    css`
      background-color: ${th('colors.pickledBluewood4')};
    `};

  ${({ variant }) =>
    variant === 'small'
      ? css`
          flex-direction: column;
          align-items: initial;
        `
      : css`
          @media ${sizes.tabletLandscape} {
            flex-direction: column;
          }
          @media ${sizes.desktop} {
            flex-direction: row;
          }
          @media ${sizes.largeDesktop} {
            flex-direction: column;
          }
        `};
`;

export const Icon = styled.img`
  width: 48px;
  height: auto;

  ${({ disabled, subscriptionOnly }) =>
    (disabled || subscriptionOnly) &&
    css`
      filter: grayscale(1);
    `};
`;

export const Info = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 50%;
    `};
`;

export const Name = styled.div`
  font-weight: 500;
  line-height: 24px;
`;

export const Description = styled.div`
  font-size: 14px;
  line-height: 20px;
  margin-bottom: auto;
`;

export const MediumText = styled.span`
  font-weight: 500;
`;
